import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { RootState } from "app/store";
import { QualityApi } from "@genesys/cloud-frontend/apis/QualityApi";
import { ComposerTemplate } from "@genesys/cloud-frontend/models";
import { API_CONFIGURATION } from "util/apiUtils";

type FavoriteTemplateState = {
    data: Array<ComposerTemplate>;
};

export const fetchFavoriteTemplates = createAsyncThunk(
    "template/fetchFavoriteTemplates",
    async () => {
        const qualityApi = new QualityApi(API_CONFIGURATION);
        return qualityApi.getEvaluationsFavoritetemplates();
    }
);

const initialState: FavoriteTemplateState = {
    data: [],
};

export const slice = createSlice({
    name: "favoriteTemplates",
    initialState,
    reducers: {},
    extraReducers(builder) {
        builder.addCase(
            fetchFavoriteTemplates.fulfilled,
            (state, { payload }) => {
                if (payload.length) {
                    state.data = payload;
                }
            }
        );
    },
});

export const getFavoriteTemplates = (state: RootState) => state.template.data;

export default slice.reducer;
